import React from 'react';
import { HStack, Spinner, NumberInput, NumberInputField, IconButton, Textarea, } from '@chakra-ui/react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import Text from '../../../../../../components/content/text';
import COLORS from '../../../../../../constants/colors';
import FONTS from '../../../../../../constants/fonts';
import Tag from '../../../../../../components/content/tag';
import { getAgendaItemTypeLabel } from '../../../../../../utils/agendaItem';
import { AgendaItemType } from '../../../../../../services/types';
import SelectAgendaItemType from '../../../../../select-agenda-item-type';
import PopOver from '../../../../../../components/surfaces/pop-over/index.web';
import styles from './styles';
export const AgendaItemInput = ({ index, onChange, agendaItemParentId, eventId, isLoading, }) => {
    const [value, setValue] = React.useState('');
    const [type, setType] = React.useState(AgendaItemType[0]);
    const [duration, setDuration] = React.useState(0);
    const [isFocused, setIsFocused] = React.useState(false);
    const inputRef = React.useRef(null);
    const handleChange = async (e) => {
        const inputValue = e.target?.value ?? '';
        console.log('Raw input value:', inputValue);
        console.log('Input value length:', inputValue.length);
        console.log('Input contains \\n:', inputValue.includes('\n'));
        console.log('Input contains \\r:', inputValue.includes('\r'));
        // Afficher les caractères spéciaux en hexadécimal
        console.log('Special characters:', inputValue.split('').map(char => char.charCodeAt(0).toString(16)));
        // Split on any type of line break (\n, \r, \r\n)
        const lines = inputValue
            .split(/[\n\r]+/)
            .map(line => line.trim())
            .filter(line => line.length > 0);
        console.log('Detected lines:', lines);
        if (lines.length > 1) {
            // Process each line
            for (const line of lines) {
                console.log('Processing line:', line);
                try {
                    await onChange(line, agendaItemParentId, eventId, type, duration, index);
                    console.log('Successfully processed:', line);
                }
                catch (error) {
                    console.error('Failed to process line:', line, error);
                }
            }
            // Clear the input after processing
            setValue('');
        }
        else {
            setValue(inputValue);
        }
    };
    const handleTypeChange = (agendaItemType) => {
        setType(agendaItemType);
    };
    const handleDurationChange = (valueString) => {
        setDuration(parseInt(valueString) || 0);
    };
    const handleSubmit = async () => {
        if (value.trim()) {
            try {
                await onChange(value.trim(), agendaItemParentId, eventId, type, duration, index);
                console.log('Submit successful for:', value);
                setValue('');
                setDuration(0);
                setType(AgendaItemType[0]);
                // Ensure focus is set after state updates
                setTimeout(() => {
                    inputRef.current?.focus();
                }, 0);
            }
            catch (error) {
                console.error('Error in handleSubmit:', error);
            }
        }
    };
    const handleCancel = () => {
        setValue('');
        setDuration(0);
        setType(AgendaItemType[0]);
    };
    const agendaItemsValues = [
        {
            label: 'Discussion',
            value: AgendaItemType[0],
        },
        {
            label: 'Presentation',
            value: AgendaItemType[1],
        },
        {
            label: 'Break',
            value: AgendaItemType[2],
        },
    ];
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && value.trim()) {
            e.preventDefault();
            handleSubmit();
            // Remove explicit blur and use setTimeout for focus
            setTimeout(() => {
                inputRef.current?.focus();
            }, 0);
        }
        else if (e.key === 'Escape') {
            handleCancel();
        }
    };
    return (<HStack width="100%" py={2} px={4} spacing={4} bg={isFocused || value ? 'white' : 'gray.50'} borderRadius="md" boxShadow="sm" opacity={isFocused || value ? 1 : 0.8} transition="all 0.2s">
      <Text color={isFocused || value ? 'gray.400' : 'gray.300'} fontSize="sm" width="24px" textAlign="center">
        {index}
      </Text>
      <Textarea ref={inputRef} value={value} placeholder={isFocused
            ? 'Type or paste (Ctrl+V) agenda items from your documents...'
            : 'Add agenda item...'} onChange={handleChange} onKeyDown={handleKeyDown} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} isDisabled={isLoading} flex={1} border="none" bg="transparent" rows={1} resize="none" minH="40px" height="40px" padding="8px" overflow="hidden" _focus={{
            boxShadow: 'none',
            border: 'none',
        }} sx={{
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            lineHeight: '24px',
        }}/>

      <NumberInput value={duration} onChange={handleDurationChange} min={0} width="2rem" isDisabled={isLoading} size="sm" opacity={isFocused || value ? 1 : 0.6}>
        <NumberInputField placeholder="Duration (min)" bg="gray.100" _hover={{ bg: 'gray.200' }} border="none" px={'0.5rem'} py={'0.25rem'} fontSize={FONTS.T1.T12Px.Regular400.value.fontSize} fontWeight={FONTS.T1.T12Px.Regular400.value.fontWeight} color={COLORS.Text.T400.value}/>
      </NumberInput>

      <PopOver from={<Tag backgroundColor={isFocused || value ? COLORS.Govrn.Blue.T100.value : 'gray.100'} color={isFocused || value ? COLORS.Govrn.Blue.T500.value : 'gray.500'} style={styles.agendaItemTypeTag} hasEndEnhancer={true}>
            {getAgendaItemTypeLabel(type)}
          </Tag>} placement="bottom-end">
        <SelectAgendaItemType agendaItemType={type} onChange={handleTypeChange}/>
      </PopOver>

      {isLoading ? (<Spinner size="sm" color="blue.500"/>) : (<HStack spacing={1} opacity={isFocused || value ? 1 : 0}>
          <IconButton aria-label="Submit" icon={<CheckIcon boxSize={3}/>} size="xs" colorScheme="green" onClick={handleSubmit} isDisabled={!value.trim()}/>
          <IconButton aria-label="Cancel" icon={<CloseIcon boxSize={3}/>} size="xs" colorScheme="red" variant="ghost" onClick={handleCancel}/>
        </HStack>)}
    </HStack>);
};
